import React from 'react';
import { Svg } from '@jg/components';
import jgLogo from 'assets/svg/justgiving_logo.svg';

import './Footer.scss';

const Footer = () => (
  <div className="footer">
    <ul className="footer__list">
      <li className="footer__list__item">
        <a href="https://www.justgiving.com/info/terms-of-service" target="_blank" rel="noopener noreferrer">Terms of Service</a>
      </li>
      <li className="footer__list__item">
        <a href="https://www.justgiving.com/info/privacy" target="_blank" rel="noopener noreferrer">Privacy</a>
      </li>
      <li className="footer__list__item">
        <a href="https://www.justgiving.com/info/cookies" target="_blank" rel="noopener noreferrer">Cookies</a>
      </li>
    </ul>

    <div className="footer__powered-by">
      Powered by

      <Svg markup={jgLogo} alt="Just Giving" className="footer__powered-by__logo" />
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/Footer.js